import React from 'react';
import PropTypes from 'prop-types';

export default class FormulaFieldOption extends React.Component {
    static propTypes = {
        data: PropTypes.object,

        onClick: PropTypes.func,
    }

    onClick = () => {
        if(this.props.onClick) this.props.onClick(this.props.data);
    }

    render() {
        return (
            <div className="ui5-field-pill s-24 m-l-10 m-b-10" onClick={this.onClick}>
                {this.props.data.field.systemIcon && <div className={Classes("ui5-ico-12", this.props.data.field.systemIcon, "m-r-5")}/>}
                {this.props.data.field.label}
            </div>
        );
    }
}